import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';

import Images from '../form/images';
import { FormRow } from '../form/formField';

import util from '../../lib/util';

const initialState = {
    height: 100,
    windowHeight: 0,
};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    email: { label: 'Email', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    fname: { label: 'Firstname', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    lname: { label: 'Lastname', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    address1: { label: 'Address', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    postalcode: { label: 'Zip', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    postalplace: { label: 'City', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    country_name: { label: 'Country', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    receive_info: { label: 'Newsletter', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    rods: { label: 'Rods', type: 'object', readonly: true, help: 'Field is DealerWeb only.' },
    position: { label: 'Position', type: 'object', readonly: true, help: 'Field is DealerWeb only.' },

    updated: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class ConsumerEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken(),
        };
        this.updateTimer = {};
        const { consumerStore } = this.props.stores;
        consumerStore.load(props.id);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'email', 'fname', 'lname', 'address1', 'postalcode', 'postalplace', 'country_name',
                    'receive_info', 'rods', 'position',
                    'updated', 'create_date'].map(f => util.makeField(f, FIELDS)),
            },
        ];
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    updateField = async (id, field, value) => {
        const { consumerStore } = this.props.stores;
        consumerStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { consumerStore } = this.props.stores;
        await consumerStore.saveField(id, field, value);
    }

    addArticleImage = async (id, imageObject) => {
        const { consumerStore } = this.props.stores;
        consumerStore.addImage(id, imageObject);
    }

    delArticleImage = async (id, imageId) => {
        const { consumerStore } = this.props.stores;
        consumerStore.delImage(id, imageId);
    }

    render(props) {
        const { height, previewServer, jwtToken } = this.state;
        const { consumerStore } = this.props.stores;
        const { consumer, saved } = consumerStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/consumers' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div class='flex-grow-1'>
                                <h4>Edit: {consumer.id}: {consumer.email}</h4>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/consumers/${props.id}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={consumer}
                            saved={saved}
                            updateField={this.updateField}
                        />)}


                    </div>
                </div>
            </div>
        );
    }
}

export default ConsumerEdit;



// WEBPACK FOOTER //
// ./components/consumers/edit.js